import {
  TwoStepPaymentFormContent,
  TwoStepPaymentFormForm,
  TwoStepPaymentFormHeader,
  TwoStepPaymentFormHeaderItem,
} from 'common/components/entities/two-step-payment-form'
import { PaymentFormStepTypeEnum } from 'common/enums/PaymentFormStepTypeEnum'
import {
  TwoStepPaymentFormInterface,
  TwoStepPaymentFormStepInterface,
} from 'common/types/entities/two-step-payment-form-interface'
import { TwoStepPaymentFormOptInStep } from 'publisher/components/entities/two-step-payment-form/two-step-payment-form-opt-in-step'
import { TwoStepPaymentFormPaymentStep } from 'publisher/components/entities/two-step-payment-form/two-step-payment-form-payment-step'
import { typedPageSelectors, usePage, usePayment } from 'publisher/store'
import paymentSelectors from 'publisher/store/payment/paymentSelectors'
import React from 'react'

export interface TwoStepPaymentFormProps {
  entity: TwoStepPaymentFormInterface
}

export const TwoStepPaymentForm = ({ entity }: TwoStepPaymentFormProps) => {
  const stepType = usePayment(paymentSelectors.getTwoStepPaymentFormStepType)
  const isPaymentStep = stepType === PaymentFormStepTypeEnum.STEP_PAYMENT
  const isOptInStep = stepType === PaymentFormStepTypeEnum.STEP_OPT_IN
  const stepOptInEntity = usePage(page =>
    typedPageSelectors.getEntityById(page, entity.childIds[0]),
  ) as TwoStepPaymentFormStepInterface | null
  const stepPaymentEntity = usePage(page =>
    typedPageSelectors.getEntityById(page, entity.childIds[1]),
  ) as TwoStepPaymentFormStepInterface | null

  if (!stepOptInEntity || !stepPaymentEntity) {
    return null
  }

  return (
    <TwoStepPaymentFormForm
      id={entity.htmlAttrId}
      border={entity.border}
      mobileBorder={entity.mobileBorder}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
    >
      <TwoStepPaymentFormHeader>
        <TwoStepPaymentFormHeaderItem
          number={1}
          backgroundColor={entity.headerBackgroundColor}
          mobileBackgroundColor={entity.mobileHeaderBackgroundColor}
          color={entity.headerTextColor}
          mobileColor={entity.mobileHeaderTextColor}
          headerUnderlineColor={entity.headerUnderlineColor}
          headline={stepOptInEntity.headline}
          subHeadline={stepOptInEntity.subHeadline}
          active={isOptInStep}
        />
        <TwoStepPaymentFormHeaderItem
          number={2}
          backgroundColor={entity.headerBackgroundColor}
          mobileBackgroundColor={entity.mobileHeaderBackgroundColor}
          color={entity.headerTextColor}
          mobileColor={entity.mobileHeaderTextColor}
          headerUnderlineColor={entity.headerUnderlineColor}
          headline={stepPaymentEntity.headline}
          subHeadline={stepPaymentEntity.subHeadline}
          active={isPaymentStep}
        />
      </TwoStepPaymentFormHeader>
      <TwoStepPaymentFormContent
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        backgroundColor={entity.backgroundColor}
        mobileBackgroundColor={entity.mobileBackgroundColor}
      >
        {isOptInStep && (
          <TwoStepPaymentFormOptInStep
            entity={stepOptInEntity}
            color={entity.buttonTextColor}
            mobileColor={entity.mobileButtonTextColor}
            backgroundColor={entity.buttonBackgroundColor}
            mobileBackgroundColor={entity.mobileButtonBackgroundColor}
          />
        )}
        {isPaymentStep && (
          <TwoStepPaymentFormPaymentStep
            entity={stepPaymentEntity}
            color={entity.buttonTextColor}
            mobileColor={entity.mobileButtonTextColor}
            backgroundColor={entity.buttonBackgroundColor}
            mobileBackgroundColor={entity.mobileButtonBackgroundColor}
            paypal={entity?.paypal}
          />
        )}
      </TwoStepPaymentFormContent>
    </TwoStepPaymentFormForm>
  )
}
